<template>
<div class="user-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user-solid"></i> Users</span>
        <el-button icon="el-icon-plus" style="float: right;padding: 0" type="text" @click="showDialog('add')">Create User</el-button>
      </div>
      
      <div class="table-data-users">
        <data-tables v-loading="loadingUser" :data="dataUserTable" border :page-size="10" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }">
          <el-table-column prop="fullname" label="Full Name" header-align="center" align="center"></el-table-column>
          <el-table-column prop="email" label="Email" header-align="center" align="center"></el-table-column>
          <el-table-column prop="role" label="Role" header-align="center" align="center">
            <template slot-scope="scope">
              <el-tag type="primary">{{ scope.row.role }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center"></el-table-column>
          <el-table-column prop="lastlogin_date" label="Last login" header-align="center" align="center"></el-table-column>
          <el-table-column prop="lastactive_date" label="Last active" header-align="center" align="center"></el-table-column>
          <el-table-column prop="uid" label="Action" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="warning" size="mini" @click="showDialog('edit', scope.row.uid)">Edit</el-button>
              <el-button icon="el-icon-delete" type="danger" size="mini" @click="deleteUser(scope.row.uid)">Del</el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="userForm" id="userForm" ref="userForm" label-width="150px" size="small" :rules="userFormRules" >
        <el-alert
        v-if="errMsg"
          :title="errMsg"
          type="error"
          show-icon>
        </el-alert>
        <el-form-item label="Full Name" prop="fullname">
          <el-input v-model="userForm.fullname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="userForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="userForm.password" @input="userForm.generate_password=''" autocomplete="off" :show-password="true"></el-input>
          <el-progress :percentage="scorePassword(userForm.password)" :color="colors" :format="formatProgress"></el-progress>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="confirm_password">
          <el-input type="password" v-model="userForm.confirm_password" autocomplete="off" :show-password="true"></el-input>
        </el-form-item>
        <el-form-item label="Generate Password">
          <el-input v-model="userForm.generate_password" class="input-with-select" readonly="readonly">
            <el-button slot="append" icon="el-icon-refresh" @click="generatePassword"></el-button>
          </el-input>
          
        </el-form-item>
        <el-form-item label="Role" prop="role">
          <el-select v-model="userForm.role" placeholder="Please select role">
            <el-option label="Super Admin" v-if="modeSuper" value="superadmin"></el-option>
            <el-option label="Admin" value="admin" v-if="!modeSuper"></el-option>
            <el-option label="User" value="user" v-if="!modeSuper"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="Project Role" v-if="!modeSuper">
          <el-checkbox-group v-model="userForm.project">
            <el-checkbox  v-for="item in projectData" :label="item.uid" :key="item.uid">{{ item.project_name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Firewall setting" v-if="superRole">
          <el-switch v-model="userForm.flag_firewallsetting"></el-switch>
        </el-form-item>
        <el-form-item label="Compliance work" v-if="superRole">
          <el-switch v-model="userForm.flag_compliancework"></el-switch>
        </el-form-item>
        <el-form-item label="Fund Transfer" v-if="superRole">
          <el-switch v-model="userForm.flag_flowfund"></el-switch>
        </el-form-item>
        <el-form-item label="Status" prop="status">
          <el-select v-model="userForm.status" placeholder="Please select status">
            <el-option label="Active" value="active"></el-option>
            <el-option label="Lock" value="lock"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Timezone"
          prop="timezone"
        >
          <el-select 
              v-model="userForm.timezone" 
              filterable 
              placeholder="Select timezone"
              
              >
              <el-option
              v-for="item in timezoneList"
              :key="item.tzCode"
              :label="item.label"
              :value="item.tzCode">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Login time">
          <el-col :span="10">
            <el-time-picker placeholder="Login From" v-model="userForm.timein" value-format="HH:mm:ss" style="width: 100%;"></el-time-picker>
          </el-col>
          <el-col class="text-center" :span="4">To</el-col>
          <el-col :span="10">
            <el-time-picker placeholder="Login To" v-model="userForm.timeout" value-format="HH:mm:ss" style="width: 100%;"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="Restrict By IP">
          <el-col :span="6">
              <el-select v-model="userForm.is_checkip">
                <el-option label="Yes" :value="true"></el-option>
                <el-option label="No" :value="false"></el-option>
              </el-select>
          </el-col>
          <el-col class="text-center" :span="4">Set</el-col>
          <el-col :span="14">
            <el-input v-model="userForm.ip_address" autocomplete="off" placeholder="Enter IP address"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="SMS Secure Login">
          <el-col :span="6">
              <el-select v-model="userForm.is_checksms">
                <el-option label="Yes" :value="true"></el-option>
                <el-option label="No" :value="false"></el-option>
              </el-select>
          </el-col>
          <el-col class="text-center" :span="4">Set</el-col>
          <el-col :span="14">
            <el-input v-model="userForm.telephone" autocomplete="off"  placeholder="Mobile number"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="Two factory Auth" prop="auth_status">
          <el-select v-model="userForm.auth_status">
            <el-option label="Enable" :value="true" disabled></el-option>
            <el-option label="Disabled" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="OTP" prop="otpcode" v-if="userAdminRole">
          <el-col :span="14">
            <el-input v-model="userForm.otpcode" autocomplete="off"  placeholder="OTP Code"></el-input>
          </el-col>
          <el-col class="text-center" :span="2">-</el-col>
          <el-col :span="8">
            <el-button type="warning" @click="onRequestOTP()" :loading="submitingOTP">Request OTP</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="submiting" type="primary" @click="submitUser()">Submit</el-button>
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
</div>
</template>

<script>
import {getUserByCompany, getUserBySuperAdmin, getUserBy, createUser, updateUser, delUser} from '@/api/user'
import {getProjectByCompany} from '@/api/project'
import {getTimeZone, requestOTP} from '@/api/utility'
export default {
  props:{
    companyUID: String,
    modeSuper: Boolean
  },
  computed:{
    userAdminRole() {
      return this.roleAuth([this.role.user, this.role.admin]);
    },
    superRole() { 
      return this.roleAuth([this.role.spadmin]);
    }
  },
  data(){
      var validatePass = (rule, value, callback) => {
        if (value === '' && this.actionForm == 'add') {
          callback(new Error('Please input the password'));
        } else {
          if (this.userForm.confirm_password !== '') {
            this.$refs.userForm.validateField('confirm_password');
          }
          callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '' && this.actionForm == 'add') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.userForm.password) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };

    return{
      submiting : false,
      submitingOTP : false,
      loadingUser:false,
      dataUserTable: [],
      dialogFormVisible:false,
      dialogTitle: '',
      actionForm: '',
      errMsg: '',
      projectData:[],
      timezoneList: [],
      colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#5cb87a', percentage: 100}
        ],
      userForm:{
        uid: "",
        fullname: "",
        email: "",
        password: "",
        confirm_password: "",
        generate_password: '',
        role: this.modeSuper ? "superadmin" : "",
        project: [],
        status: "active",
        timein: "",
        timeout: "",
        timezone: "Europe/London",
        is_checkip: true,
        ip_address: "",
        is_checksms: true,
        telephone: "",
        auth_status: false,
        flag_compliancework: false,
        flag_flowfund: false,
        flag_firewallsetting: false,
        otpcode: ""
      },
      userFormRules:{
        email: [{
            required: true,
            message: "Please enter email contact",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: ["blur"],
          }],
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm_password: [{ validator: validatePass2, trigger: "blur" }],
        role: [{
            required: true,
            message: "Please select role",
            trigger: "blur",
          }],
        fullname: [{
            required: true,
            message: "Please enter fullname",
            trigger: "blur",
          }],
        timezone: [{
            required: true,
            message: "Please enter timezone",
            trigger: "blur",
          }],
        otpcode: [{
            required: true,
            message: "Please enter OTP code via request OTP",
            trigger: "blur",
          }]
      }
    }
  },
  methods:{
    formatProgress(percentage) {
      if(percentage < 60){
        return 'Weak'
      }else if(percentage < 80){
        return 'Strong'
      }else if(percentage >= 80){
        return 'Good'
      }
        
    },
    getUserData(){
      this.loadingUser = true
      getUserByCompany(this.companyUID).then(({result, data}) =>{
        this.loadingUser = false
        if(result){
          this.dataUserTable = data
        }
      })
    },
    getProjectByCompanyData(){
      getProjectByCompany(this.companyUID).then(({result, data})=>{
        if(result){
          this.projectData = data
        }
      })
    },
    getSuperAdminUserData(){
      this.loadingUser = true
      getUserBySuperAdmin().then(({result, data}) =>{
        this.loadingUser = false
        if(result){
          this.dataUserTable = data
        }
      })
    },
    getUerLists(){
      if(this.modeSuper){
        this.getSuperAdminUserData()
      }else{
        this.getUserData()
      }
    },
    getUserDataToEdit(uid){
      const loading = this.$notifyloading('Loading data...');
      getUserBy(uid).then(({result, data}) =>{
        loading.close()
        if(result){
          this.userForm.uid = data.uid
          this.userForm.email = data.email
          this.userForm.role = data.role
          this.userForm.project = data.project_role
          this.userForm.fullname = data.fullname
          this.userForm.status = data.status
          this.userForm.timein = data.timein
          this.userForm.timeout = data.timeout
          this.userForm.timezone = data.timezone
          this.userForm.is_checkip = data.is_checkip === 1
          this.userForm.ip_address = data.ip_address
          this.userForm.is_checksms = data.is_checksms === 1
          this.userForm.telephone = data.telephone
          this.userForm.auth_status = data.auth_status === 1
          this.userForm.flag_compliancework = data.flag_compliancework === 1
          this.userForm.flag_flowfund = data.flag_flowfund === 1
          this.userForm.flag_firewallsetting = data.flag_firewallsetting === 1
          this.dialogFormVisible = true
          if(!this.modeSuper){
            this.getProjectByCompanyData()
          }
        }
      })
    },
    showDialog(action, uid){
      this.actionForm = action
      this.userForm.uid = ''
      this.resetForm();
      if(this.actionForm === 'add'){
        this.dialogTitle = 'Create User'
        if(!this.modeSuper){
          this.getProjectByCompanyData()
        }
        this.dialogFormVisible = true
      }else{
        this.dialogTitle = 'Update User'
        this.getUserDataToEdit(uid)
      }
      
      
    },
    mapData(){
      const formData = {
        company_uid: this.companyUID,
        fullname: this.userForm.fullname,
        email: this.userForm.email,
        password: this.userForm.password,
        role: this.userForm.role,
        project_role: this.userForm.project.join(','),
        status:  this.userForm.status,
        timein: this.userForm.timein,
        timeout: this.userForm.timeout,
        timezone: this.userForm.timezone,
        is_checkip: this.userForm.is_checkip,
        ip_address: this.userForm.ip_address,
        is_checksms: this.userForm.is_checksms,
        telephone: this.userForm.telephone,
        auth_status: this.userForm.auth_status,
        flag_compliancework: this.userForm.flag_compliancework,
        flag_flowfund: this.userForm.flag_flowfund,
        flag_firewallsetting: this.userForm.flag_firewallsetting,
        otpcode: this.userForm.otpcode
      }
      if(this.actionForm === 'edit'){
        if(!formData.password){
          delete formData.password
        }
        delete formData.company_uid
      }

      return formData
    },
    createUser(){
      const formData = this.mapData()
      this.submiting = true
      this.errMsg = ''
      createUser(formData).then(({ result, message}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Create user successfully`,
            type: 'success',
            duration: 2000
          });
          this.getUerLists()
          this.dialogFormVisible = false
        }else{
          this.errMsg = message
        }
      })
    },
    updateUser(){
      const formData = this.mapData()
      this.submiting = true
      this.errMsg = ''
      updateUser(this.userForm.uid, formData).then(({ result, message}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Update user successfully`,
            type: 'success',
            duration: 2000
          });
          this.getUerLists()
          this.dialogFormVisible = false
        }else{
          this.errMsg = message
        }
      })
    },
    submitUser(){

      this.$refs.userForm.validate((valid) => {
        if(valid){
          if(this.actionForm === 'add'){
            this.createUser()
          }else{
            this.updateUser()
          }
        }else{
          console.log('error submit!!')
          return false
        }
      });
    },
    deleteUser(uid){
      this.$confirm('Are you sure you want to delete this User, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delUser(uid).then(({result}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete user successfully`,
                type: 'success',
                duration: 2000
              });
              this.getUerLists()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
    resetForm() {
      this.userForm.role = "user"
      this.userForm.project = []
      this.userForm.fullname = ""
      this.userForm.email = ""
      this.userForm.timein = ""
      this.userForm.timeout = ""
      this.userForm.timezone = "Europe/London"
      this.userForm.is_checkip = false
      this.userForm.ip_address = ""
      this.userForm.is_checksms = false
      this.userForm.telephone = ""
      this.userForm.auth_status = false
      this.userForm.otpcode = ""
      this.userForm.password = ""
      this.userForm.confirm_password = ""
      this.userForm.generate_password = ""
    },
    generatePassword() {
      var length = 16,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]\:;?><,./-=",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.userForm.generate_password = retVal
      
    },
    scorePassword(pass) {
        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score) > 100 ? 100 : parseInt(score);
    },
    getTimeZone(){
      getTimeZone().then(({ result, data})=>{
        if(result){
          this.timezoneList = data
        }
      })
    },
    onRequestOTP(){
      this.submitingOTP = true
      requestOTP().then(({ result })=>{
        if(result){
          this.submitingOTP = false
          this.$alert('Your request has been send. Please contact project admin', 'Request OTP', {
            confirmButtonText: 'OK'
          });

        }
      })
    }
  },
  created(){
    this.getUerLists()
    this.getTimeZone()
  }
}
</script>

<style lang="scss">
.user-manager-container{
  .el-checkbox {
    display: block;
  } 
}
</style>